import React from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import WaitDialog from '../../../widgets/WaitDialog';

import GetCorsi from '../../../services/getCorsi';
import getStudenti from '../../../services/getStudentiForBilling';
import getPianoPagamentiCorso from '../../../services/getPianoPagamentiCorso';
import GestioneRateWidget from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import addPianoPagamentiCorsoStudenti from "../../../services/addPianoPagamentiCorsoStudenti";
import getRataStatus from "../../../services/getRataStatus";
import getCorsi from "../../../services/getCorsi";
import getPianiCorsoStudente from "../../../services/getPianiCorsoStudente";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../../utils/Locales";
import Utils from "../../../utils/utils";

let t = translateString;

export default class StudenteDetails extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
        isLoading: true,
    }


  }

  async reload(){
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentStudente = cookies.get('currentStudent', { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });
    this.corsi = await GetCorsi(username, token);

    this.studenti = await getStudenti(username, token);
    this.studente = this.studenti.find(s => s.id == currentStudente);

    var corsi = await getCorsi(username, token);
    this.listaCorsi = await getPianiCorsoStudente(username, token, currentStudente);

    this.studente.corsi.split(';').forEach( corso => {
      if (corso == '') return;
      var c = this.corsi.find(temp => temp.id == corso);
      if (c == undefined) return;
      if (this.listaCorsi.find(c => c.id_corso == corso) != undefined) return;
      this.listaCorsi.push({
        id_corso: c.id,
        id_studente: this.studente.id,
        piano : {}
      });
    })

    this.corsiDetails = {};

    for (var c of this.listaCorsi){
      var corsoId = c.id_corso;
      if (corsoId == '') continue;
      var corso = corsi.find(c => c.id == corsoId);
      var pianoRateCorso = await getPianoPagamentiCorso(username, token, corsoId);
      var pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(username, token, corsoId, this.studente.id);
      var rateStatus = await getRataStatus(username, token, corsoId, this.studente.id);
      this.corsiDetails[corsoId] =  {
                                      corso: corso,
                                      rateCorso: pianoRateCorso,
                                      rateCorsoStudente: pianoRateCorsoStudente,
                                      rateStatus: rateStatus
                                    };
    }

    this.setState({
      corsiDetails: this.corsiDetails, 
      isLoading: false,
    });
  }

  async componentDidMount(){
    await this.reload();

  }

  render () {

    const cookies = new Cookies();

    this.searchCols = ['nome', 'cognome', 'mail'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.state.corsiDetails == undefined) return <div></div>;
    
    this.custom = this.pianoRateCorsoStudente != undefined && this.pianoRateCorsoStudente != null;

    return (
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('rate_di') + this.studente.nome.replace(/\\/g, '') + ' ' + this.studente.cognome.replace(/\\/g, '')}/>
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 10, marginLeft: 5 }}>
                <img alt="" src={ require('../../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('rate_stud')}</p><br/>
          </div>

        {
          this.listaCorsi.map(c => {
            var corsoId = c.id_corso;
            if (corsoId == '') return null;
            if (this.corsiDetails[corsoId].corso == undefined) return null;
            var corsoName = this.corsiDetails[corsoId].corso.name;
            var pianoRateCorso = this.corsiDetails[corsoId].rateCorso;
            var pianoRateCorsoStudente = this.corsiDetails[corsoId].rateCorsoStudente;

            return (<div>
              <br/>
              <div style={{fontSize: 20, marginLeft: 5, marginBottom: 20, fontWeight: 'bold'}}>{corsoName} - <i style={{fontSize: 15, cursor: 'pointer', color: '#ff3333'}} onClick={() => {
                    cookies.set('currentStudent', this.studente.id, { path: '/' });
                    cookies.set('currentCourse', corsoId, { path: '/' });
                    window.location.href =  '/' + this.dbPath + '/#/billing/editStudente';
              }}>
                <img alt="" src={ require('../../../images/edit.png') } style={{ height: 20, width: 20, marginTop: -8 }} title={t('modifica_piano')} />
              </i></div>
              <GestioneRateWidget 
              piano={pianoRateCorsoStudente != undefined ? pianoRateCorsoStudente : pianoRateCorso} 
              custom={pianoRateCorsoStudente != undefined} 
              isStudent={true}
              compactMode={true}
              studentObj={this.studente}
              corso={this.corsiDetails[corsoId].corso}
              onSalva={async (costo, rate) => {
                var json ={
                  costo: costo, 
                  rate: rate
                };

                if (this.custom == false){
                  if (window.confirm(t('a_piano_custom')) == false) return;
                }

                const cookies = new Cookies();
                const username = cookies.get('username', { path: '/' });
                const token = cookies.get('token', { path: '/' });
                await addPianoPagamentiCorsoStudenti(username, token, this.corso.id, this.studente.id, JSON.stringify(json));
                this.custom = true;
                Utils.showSuccess(t('salvataggio_fatto'));
        }} />

            </div>);
          })

        }
        

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </div>
    );
  }
}

